// Cookie banner + tags (server side: web/tracking.py).
//
// The banner is vanilla-cookieconsent, bundled here - nothing from a third
// party loads before the visitor says yes. Consent Mode v2 "basic": gtag.js
// and the Meta pixel are added to the page only once their category is
// accepted; taking a category back deletes its cookies and reloads the page.
//
//   analytics   GA4, Microsoft Clarity (heatmaps, session recordings)
//   marketing   Google Ads (conversions + enhanced conversions), Meta pixel
//
// track(name, params) takes GA4's event names and sends each event where it
// belongs; events a page names in the view (json "tracking-events") go out
// once the tags are there, also when the yes comes later on the same page.
// Locally (DEBUG, no ids) the config is "dry": banner and events as live,
// but no script is loaded and every event is logged to the console.
var CookieConsent = require('vanilla-cookieconsent');     // the UMD build

var json = function (id) {
  var el = document.getElementById(id);
  try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
};

var cfg = json('tracking-config');
var pageEvents = json('tracking-events') || [];
var pageSent = { ga4: false, clarity: false, ads: false, meta: false };     // which tag got this page's events
var on = { analytics: false, marketing: false };
var ready = { gtag: false, ga4: false, clarity: false, ads: false, meta: false };

// GA4 name -> Meta standard event (anything else is GA4 only)
var META_EVENTS = { generate_lead: 'Lead', view_item: 'ViewContent', begin_checkout: 'InitiateCheckout', purchase: 'Purchase' };
var META_CUSTOM = { preview_start: 'FreeCardStart' };
// GA4 name -> Google Ads conversion label key
var ADS_CONVERSIONS = { purchase: 'purchase', generate_lead: 'lead' };

var addScript = function (src) {
  if (cfg.dry) { console.info('[tracking] lokal, nicht geladen:', src); return; }
  var s = document.createElement('script');
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

var loadGtag = function () {
  if (ready.gtag) return;
  ready.gtag = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied',
  });
  window.gtag('js', new Date());
  addScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.ga4 || cfg.ads));
};

var loadClarity = function () {
  if (ready.clarity) return;
  ready.clarity = true;
  // Clarity's own loader, unrolled; it queues calls until the script is there
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  addScript('https://www.clarity.ms/tag/' + encodeURIComponent(cfg.clarity));
};

var loadMeta = function () {
  if (ready.meta) return;
  ready.meta = true;
  // the pixel's own loader, unrolled
  var fbq = window.fbq = function () {
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments); else fbq.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
  addScript('https://connect.facebook.net/en_US/fbevents.js');
  // no automatic event detection / page metadata scraping - only what we send (privacy text);
  // "automatic advanced matching" must also stay off in Events Manager
  fbq('set', 'autoConfig', false, cfg.meta);
  fbq('init', cfg.meta);
  fbq('track', 'PageView');
};

var apply = function () {
  on.analytics = (!!cfg.ga4 || !!cfg.clarity) && CookieConsent.acceptedCategory('analytics');
  on.marketing = (!!cfg.ads || !!cfg.meta) && CookieConsent.acceptedCategory('marketing');
  var google = (on.analytics && cfg.ga4) || (on.marketing && cfg.ads);
  if (google) {
    loadGtag();
    var m = on.marketing ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      analytics_storage: on.analytics ? 'granted' : 'denied', ad_storage: m, ad_user_data: m, ad_personalization: m,
    });
    if (on.analytics && cfg.ga4 && !ready.ga4) { ready.ga4 = true; window.gtag('config', cfg.ga4); }
    if (on.marketing && cfg.ads && !ready.ads) { ready.ads = true; window.gtag('config', cfg.ads, { allow_enhanced_conversions: true }); }
  }
  if (on.analytics && cfg.clarity) {
    loadClarity();
    // EEA visitors: without this signal Clarity records without cookies (no returning visitors)
    window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: on.marketing ? 'granted' : 'denied' });
  }
  if (on.marketing && cfg.meta) loadMeta();
  // the page's own events (view_item, begin_checkout, purchase) go to every tag once - also to a
  // tag switched on later on the same page (only Statistik first, Marketing afterwards)
  ['ga4', 'clarity', 'ads', 'meta'].forEach(function (dest) {
    if (ready[dest] && !pageSent[dest]) {
      pageSent[dest] = true;
      pageEvents.forEach(function (e) { track(e.name, e.params, dest); });
    }
  });
};

var metaParams = function (p) {
  var out = {};
  if (p.value != null) { out.value = p.value; out.currency = p.currency || 'EUR'; }
  if (p.items) {
    out.content_ids = p.items.map(function (i) { return i.item_id; });
    out.content_type = 'product';
    out.num_items = p.items.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);
  }
  if (p.style) out.content_name = p.style;
  return out;
};

function track(name, params, only) {
  if (!cfg) return;
  var to = function (dest) { return !only || only === dest; };
  params = params || {};
  if (cfg.dry) console.info('[tracking]', name, params, on);
  var email = params.email;
  var clean = {};
  Object.keys(params).forEach(function (k) { if (k !== 'email') clean[k] = params[k]; });

  if (to('ga4') && on.analytics && ready.ga4) window.gtag('event', name, Object.assign({ send_to: cfg.ga4 }, clean));

  // Clarity: every event by name, so recordings can be filtered by it (e.g. sessions with generate_lead)
  if (to('clarity') && on.analytics && ready.clarity) window.clarity('event', name);

  if (to('ads') && on.marketing && ready.ads && ADS_CONVERSIONS[name]) {
    var label = cfg.labels[ADS_CONVERSIONS[name]];
    if (label) {
      if (email) window.gtag('set', 'user_data', { email: email });     // hashed by gtag
      window.gtag('event', 'conversion', {
        send_to: cfg.ads + '/' + label, value: clean.value, currency: clean.currency, transaction_id: clean.transaction_id || '',
      });
    }
  }

  if (to('meta') && on.marketing && ready.meta) {
    var id = clean.transaction_id ? { eventID: clean.transaction_id } : {};     // = the server's event_id
    if (META_EVENTS[name]) window.fbq('track', META_EVENTS[name], metaParams(clean), id);
    else if (META_CUSTOM[name]) window.fbq('trackCustom', META_CUSTOM[name], metaParams(clean));
  }
}

function start() {
  if (!cfg) return;
  var categories = { necessary: { enabled: true, readOnly: true } };
  var sections = [
    { title: 'Deine Wahl',
      description: 'Hier entscheidest du, was wir außer dem Nötigsten einsetzen dürfen. Ohne Zustimmung funktioniert alles genauso. Du kannst deine Wahl jederzeit unten auf der Seite unter „Cookie-Einstellungen“ ändern.' },
    { title: 'Notwendig <span class="pm__badge">Immer an</span>', linkedCategory: 'necessary',
      description: 'Deine Sitzung, der Schutz vor gefälschten Formularen und diese Auswahl. Ohne sie gehen Gratis-Karte, Kasse und Anmeldung nicht.' },
  ];
  if (cfg.ga4 || cfg.clarity) {
    categories.analytics = { autoClear: { cookies: [{ name: /^_ga/ }, { name: '_gid' }, { name: /^_cl(ck|sk)$/ }], reloadPage: true } };
    var stats = [];
    if (cfg.ga4) stats.push('Google Analytics zeigt uns, welche Seiten besucht werden und wo es hakt – etwa wie viele Gratis-Karten fertig werden und wie viele davon zu einem Deck.');
    if (cfg.clarity) stats.push('Microsoft Clarity zeichnet auf, wie die Seite benutzt wird (Klicks, Scrollen, Mausbewegungen), damit wir sehen, wo jemand nicht weiterkommt. Eingaben, Fotos und Karten werden dabei verdeckt.');
    var statsWho = [cfg.ga4 && 'Google Ireland Ltd.', cfg.clarity && 'Microsoft Ireland Operations Ltd.'].filter(Boolean).join(', ');
    sections.push({ title: 'Statistik', linkedCategory: 'analytics',
      description: stats.join(' ') + ' Anbieter: ' + statsWho + '; Daten können in die USA übertragen werden.' });
  }
  if (cfg.ads || cfg.meta) {
    categories.marketing = { autoClear: { cookies: [{ name: /^_gcl/ }, { name: '_fbp' }, { name: '_fbc' }], reloadPage: true } };
    var who = [cfg.ads && 'Google Ads', cfg.meta && 'Meta (Facebook, Instagram)'].filter(Boolean).join(' und ');
    sections.push({ title: 'Marketing', linkedCategory: 'marketing',
      description: who + ' messen, ob unsere Anzeigen zu Gratis-Karten und Bestellungen führen, und zeigen sie Leuten, die sich dafür interessieren könnten. Nach einer Bestellung melden wir sie mit gehashter E-Mail-Adresse und Bestellwert auch direkt an diese Anbieter – nur wenn du hier zustimmst. Anbieter: Google Ireland Ltd., Meta Platforms Ireland Ltd.; Daten können in die USA übertragen werden.' });
  }
  sections.push({ title: 'Mehr dazu', description: 'Alles Weitere steht in unserer <a href="' + cfg.privacy + '">Datenschutzerklärung</a>.' });

  CookieConsent.run({
    revision: cfg.revision,
    cookie: { name: 'cc_cookie', expiresAfterDays: 182, sameSite: 'Lax' },
    guiOptions: {
      // one button, "Einstellungen anpassen" is a quiet link beneath it; centred over a
      // dimmed page, so it reads as a decision to make (Dennis, 2026-09-26)
      consentModal: { layout: 'box', position: 'middle center', equalWeightButtons: false, flipButtons: false },
      preferencesModal: { layout: 'box', equalWeightButtons: false, flipButtons: false },
    },
    disablePageInteraction: true,
    categories: categories,
    onConsent: apply,
    onChange: apply,
    language: {
      default: 'de',
      translations: {
        de: {
          consentModal: {
            title: 'Dürfen wir mitzählen?',
            description: 'Wir möchten sehen, wie TrumpfBlatt genutzt wird und welche Werbung wirkt – mit Diensten von Google, Microsoft und Meta. Das passiert nur, wenn du zustimmst; ohne geht alles genauso. <a href="' + cfg.privacy + '">Datenschutz</a>',
            acceptAllBtn: 'Alle akzeptieren',
            showPreferencesBtn: 'Einstellungen anpassen',
          },
          preferencesModal: {
            title: 'Cookie-Einstellungen',
            acceptAllBtn: 'Alle akzeptieren',
            savePreferencesBtn: 'Auswahl speichern',
            closeIconLabel: 'Schließen',
            sections: sections,
          },
        },
      },
    },
  });
}

module.exports = { start: start, track: track };
